import { useMemo } from 'react';

const StatusCode = {
    IN_WORK_OR_CLOSED: 0,
    REQUIRED_ADDITIONAL_INFO: 1,
    ADDITIONAL_INFO_WAS_SEND: 2,
};

export const useDisable = ({ feedbacks = [], statusDate, internalCode }) =>
    useMemo(() => {
        const hasReceiptDate = feedbacks.some((feedback) => Boolean(feedback.receiptDate));

        const disableDelete = hasReceiptDate || Boolean(statusDate);
        const disableEdit =
            disableDelete && internalCode !== undefined && internalCode !== null && internalCode !== StatusCode.REQUIRED_ADDITIONAL_INFO;

        return { disableEdit, disableDelete };
    }, [feedbacks, internalCode]);
